// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2b7e49ee","368":"ca71e25d","453":"ed3810f9","515":"e8ebbfcb","558":"71ec5c2f","908":"d07610e1","929":"09c7400a"}[chunkId] + ".chunk.js";
};